import { render, staticRenderFns } from "./rename-company.vue?vue&type=template&id=16635365&scoped=true"
import script from "./rename-company.vue?vue&type=script&lang=js"
export * from "./rename-company.vue?vue&type=script&lang=js"
import style0 from "./rename-company.vue?vue&type=style&index=0&id=16635365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16635365",
  null
  
)

export default component.exports